import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { ElementAttribute, fontFamilyList } from '@models/editor';
import { SelectedElementsService } from '@service/canvas/selected-elements.service';
import { defaultNumberInputArrowedKey, KeyFilterSerivce } from '@service/key-filter.service';

@Component({
    selector: 'app-text-design-options',
    templateUrl: './text-design-options.component.html',
    styleUrls: ['./text-design-options.component.css', './../design-side-menu/design-side-menu.component.css'],
    standalone: false,
})
export class TextDesignOptionsComponent implements OnChanges {
    @Input() selectedElement;

    readonly ALLOWED_KEYS = defaultNumberInputArrowedKey;
    readonly FONT_FAMILY_LIST = fontFamilyList;
    readonly FONT_SIZE_MAX: number = 256;
    readonly FONT_SPACING_MAX: number = 100;

    fontFamilyDropdownShow: boolean = false;
    fontFamily: string = fontFamilyList[0];

    fontSize;
    letterSpacing;

    constructor(
        private selectionService: SelectedElementsService,
        private keyFilterService: KeyFilterSerivce
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selectedElement && this.selectedElement) {
            this.fontFamily =
                this.selectedElement?.getAttribute(ElementAttribute.fontFamily) || this.FONT_FAMILY_LIST[0];
            this.fontSize = this.selectedElement?.getAttribute(ElementAttribute.fontSize);
            this.letterSpacing = this.selectedElement.getAttribute(ElementAttribute.letterSpacing) || '0';
        }
    }

    fontFamilyItemClick(fontFamily: string) {
        this.selectedElement.setAttribute(ElementAttribute.fontFamily, fontFamily);
        this.selectedElement.setAttribute(ElementAttribute.fontStyle, 'normal');
        this.selectedElement.setAttribute(ElementAttribute.fontWeight, 'normal');
        this.fontFamily = fontFamily;
    }

    fontFamilyDropDownClick(event: MouseEvent) {
        event.stopImmediatePropagation();
        if (this.fontFamilyDropdownShow) {
            this.fontFamilyDropDownClose();
            return;
        }
        this.fontFamilyDropdownShow = true;
        document.addEventListener('click', this.fontFamilyDropDownClose);
    }

    fontFamilyDropDownClose = () => {
        this.fontFamilyDropdownShow = false;
        document.removeEventListener('click', this.fontFamilyDropDownClose);
    };

    handleSizeChange({ name, value }) {
        if (value > this.FONT_SIZE_MAX) {
            this.fontSize = String(this.FONT_SIZE_MAX);
        } else {
            this.fontSize = value;
        }

        this.selectedElement.setAttribute(ElementAttribute.fontSize, this.fontSize);
        this.selectionService.setSelectedElements([this.selectedElement]);
    }

    handleSpacingChange({ name, value }) {
        if (value > this.FONT_SPACING_MAX) {
            this.letterSpacing = String(this.FONT_SPACING_MAX);
        } else {
            this.letterSpacing = value;
        }

        this.selectedElement.setAttribute(ElementAttribute.letterSpacing, this.letterSpacing);
        this.selectionService.setSelectedElements([this.selectedElement]);
    }

    validFontSizeKeyDown(eventObj: { event: KeyboardEvent; value }) {
        const { event, value } = eventObj;
        if (this.checkStringLimit(value) && event.key !== 'Backspace') {
            event.preventDefault();
            return;
        }

        const shouldBlockKey = this.keyFilterService.shouldPreventDefault(event, this.ALLOWED_KEYS);
        if (shouldBlockKey) event.preventDefault();
    }

    validSpacingKeyDown(eventObj: { event: KeyboardEvent; value }) {
        const { event, value } = eventObj;
        if (this.checkStringLimit(value) && event.key !== 'Backspace') {
            event.preventDefault();
            return;
        }

        const shouldBlockKey = this.keyFilterService.shouldPreventDefault(event, this.ALLOWED_KEYS);
        if (shouldBlockKey) event.preventDefault();
    }

    checkStringLimit(value) {
        return String(value).length >= 20;
    }
}
